"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRegionalPathname = void 0;
const parseRegionalPathname = ({ pathname, regionalLandingRoutes, regionNames, }) => {
    const regex = new RegExp(`^/?(${regionNames.join('|')})?(${regionalLandingRoutes.join('|')})$`);
    const result = withTrailingSlash(pathname).match(regex);
    if (!result) {
        return null;
    }
    const [, capital, route] = result;
    return { capital, route };
};
exports.parseRegionalPathname = parseRegionalPathname;
function withTrailingSlash(route) {
    return route[route.length - 1] === '/' ? route : `${route}/`;
}
//# sourceMappingURL=index.js.map